import Axios from "axios";
import {
    SET_CMS_DOCUMENT_LIST,
    UNSET_CMS_DOCUMENT_LIST
} from "@/store/mutation-types";

import { 
    getTransmittalsList,
    uploadCmsFile,
    saveCmsTransmittal,
    updateCmsTransmittal,
    sendDocumentApproval,
    showCmsFile,
    downlosdCmsFileUrl,
    getCmsTransmittalById
} from "@/store/api";

const state = {
    getTransmittalsList: [],
};

const getters = {
    getTransmittalsList(state) {
        return state.getTransmittalsList;
    },
};

const mutations = {
    [SET_CMS_DOCUMENT_LIST](state, data) {
        state.getTransmittalsList = data;
    },
    [UNSET_CMS_DOCUMENT_LIST](state) {
        state.getTransmittalsList = [];
    },
};

const actions = {
    saveCmsTransmittal({ commit }, { formData, onProgress, signal }) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
            const axiosConfig = {
                headers: {
                    "Content-Type": "multipart/form-data"
                },
                onUploadProgress: (progressEvent) => {
                    if (progressEvent.lengthComputable) {
                        const percentComplete = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        if (typeof onProgress === 'function') {
                            onProgress(percentComplete);
                        }
                    }
                },
            };

            if (signal) {
                axiosConfig.signal = signal;
            }

            Axios.post(saveCmsTransmittal, formData, axiosConfig)
            .then((response) => {
                if (typeof onProgress === 'function') {
                    onProgress(100);
                }
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then(() => {
                commit("UNSET_LOADING");
            });
        });
    },

    updateCmsTransmittal({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            const url = `${updateCmsTransmittal}/${id}`;
            Axios.put(url, data)
                .then((response) => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getTransmittalsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });
            
            Axios.get(getTransmittalsList, { params: data })
                .then((response) => {
                    commit('SET_CMS_DOCUMENT_LIST', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    commit('UNSET_CMS_DOCUMENT_LIST');
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getCmsTransmittalById({ commit }, id) {
        return new Promise((resolve, reject) => {
            commit("SET_LOADING", { color: "primary" });

            const url = `${getCmsTransmittalById}/${id}`;
                     
            Axios.get(url)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    }

};

export default {
    state,
    getters,
    actions,
    mutations,
};
